import { clientApi } from "../interceptor/_clientInstance";

export const getPersonalInfo = async () => {
  const response = await clientApi.get(`/c/auth/profile/`);
  return response.data;
};

export const updatePersonalInfo = async (data: { first_name?: string; last_name?: string, email?: string }) => {
  return await clientApi.put(`/c/auth/profile/`, data);
};